export default {
      id: "ic_normal_questionmark-usage",
      viewBox: "0 0 24 25",
      url: "/" + "images/icons.3.109.2.svg#ic_normal_questionmark-usage",
      toString: function () {
        return this.url;
      }
    }